interface LegalDisclaimersProps {
  showNote?: boolean;
}

export function LegalDisclaimers({ showNote = false }: LegalDisclaimersProps) {
  return (
    <div className="w-full text-[0.45rem] sm:text-[0.5rem] md:text-[0.55rem] lg:text-[0.6rem] xl:text-[0.65rem] text-[var(--color-text)] text-center max-w-[100vw] leading-tight select-none pointer-events-none px-1 py-0.5 relative" style={{ zIndex: 15 }}>
      <div>
        <strong>Important:</strong> Ensure you adhere to 3M's Global Responsible AI Use Policy and do not use any highly sensitive data.
        <br />
        For matters that are subject to 3M legal hold, retain any final 3M Navigator output.
        {showNote && (
          <div>
            <br />
            <strong>Note:</strong> Generative AI agents may produce inaccurate information about people, places, or facts.
          </div>
        )}
      </div>
    </div>
  );
}